import { forwardRef } from 'react';
import { wrapperCls } from './styles/ErrorMessage.js';
import { jsx } from 'react/jsx-runtime';

const ErrorMessage = /*#__PURE__*/forwardRef(function ErrorMessage(props, ref) {
  return /*#__PURE__*/jsx("span", {
    ref: ref,
    className: wrapperCls,
    children: "Der opstod en fejl under indl\xE6sningen, vi beklager."
  });
});

export { ErrorMessage };
//# sourceMappingURL=ErrorMessage.js.map
